export const SESSION_EXPIRY_KEY = 'dss360_session_expiry'

export function decodeJwtExpiryMs(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replaceAll('-', '+').replaceAll('_', '/')))
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null
  }
  catch {
    return null
  }
}

export function persistSessionExpiry(expiryMs) {
  try {
    if (typeof expiryMs === 'number')
      localStorage.setItem(SESSION_EXPIRY_KEY, String(expiryMs))
    else
      localStorage.removeItem(SESSION_EXPIRY_KEY)
  }
  catch {
    // localStorage unavailable (private mode/blocked): degrade gracefully
  }
}

export function readSessionExpiry() {
  try {
    const value = Number(localStorage.getItem(SESSION_EXPIRY_KEY))
    return Number.isFinite(value) && value > 0 ? value : null
  }
  catch {
    return null
  }
}

export function clearSessionExpiry() {
  try {
    localStorage.removeItem(SESSION_EXPIRY_KEY)
  }
  catch {
    // localStorage unavailable: nothing to clear
  }
}
